import React from 'react';
import './Buttons.css';
import pawImage from '../../assets/cat_paw.png';
import steamImage from '../../assets/steam.png';
import metaImage from '../../assets/meta.png';
import googlePlayImage from '../../assets/googleplay.png';
import appStoreImage from '../../assets/apple.png';
import playstationImage from '../../assets/playstation.png';
import picoImage from '../../assets/pico.png';

const Buttons = () => {
  return (
    <div className="hero-buttons-content">
      <h1 className="hero-title">Available Now</h1>
      <img src={pawImage} alt="Paw Print" className="paw-image" />
      <div className="hero-buttons-container">
        <a href="https://store.steampowered.com/app/3016840/I_Am_Cat/?utm_source=iamcatsteam" target="_blank" rel="noopener noreferrer" className="hero-buttons">
          <img src={steamImage} alt="Steam" />
        </a>
        <a href="https://www.meta.com/en-gb/experiences/6061406827268889/?utm_source=iamcatmeta" target="_blank" rel="noopener noreferrer" className="hero-buttons">
          <img src={metaImage} alt="Meta" />
        </a>
        <a href="https://store.playstation.com/en-us/concept/10012021/?utm_source=iamcatapple" target="_blank" rel="noopener noreferrer" className="hero-buttons">
          <img src={playstationImage} alt="PlayStation" />
        </a>
        <a href="https://store-global.picoxr.com/global/detail/1/7475335600636198967" target="_blank" rel="noopener noreferrer" className="hero-buttons">
          <img src={picoImage} alt="Pico" />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.NewFolderGames.IAmCat" target="_blank" rel="noopener noreferrer" className="hero-buttons">
          <img src={googlePlayImage} alt="Google Play" />
        </a>
        <a href="https://apps.apple.com/by/app/i-am-cat-original-game/id6740168334" target="_blank" rel="noopener noreferrer" className="hero-buttons">
          <img src={appStoreImage} alt="App Store" />
        </a>
        
        
      </div>
    </div>
  );
};

export default Buttons;
